<script setup>

</script>

<template>
  <div class="main" id="top">
    <router-view />
  </div>
</template>

<style lang="scss">

</style>